import {
    Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';

import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';
import {
    CommonStylesRenderDirective,
} from '@features/cms-render/ui/directives/common-styles-render/common-styles-render.directive';
import { ContentSwitchRender } from '@features/cms-render/ui/render-blocks/switch-content/switch-content.models';

@Component({
    selector: 'slice-tabs',
    templateUrl: './slice-tabs.component.html',
    styleUrls: ['./slice-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliceTabsComponent extends CommonStylesRenderDirective implements OnInit, OnDestroy {
    @Input() public element: ContentItemTree;

    public contentSwitch: ContentSwitchRender = { isContentAVisible: false, isContentBVisible: false };

    private readonly onDestroy$ = new Subject();

    public tabs: Array<{ name: string; children: Array<{ name: string; definitionId: string }> }> = [];

    public selectedTabIndex = 0;

    constructor() {
        super();
    }

    public ngOnInit(): void {
        this.loadTabs();
    }

    public loadTabs() {
        if (!this.element?.children) { return; }

        this.tabs = this.element.children.map((child, index) => {
            const tabSettings = this.element.settings?.general?.tabs[index]?.text;
            const children = child.children.map(subChild => ({
                name: subChild.settings?.general?.text,
                definitionId: subChild?.definitionId,
            }));

            return {
                name: tabSettings,
                children: children,
            };
        });
    }

    private selectTab(index: number) {
        this.selectedTabIndex = index;
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next(undefined);
        this.onDestroy$.complete();
    }
}
